import { FC } from 'react'

import { Spinner } from '@trustycars/genie-ui/components'

export const CenterLoader: FC<{ overlay?: boolean }> = ({ overlay }) => (
  <Spinner
    color="neutral.100"
    style={{
      width: 'auto',
      display: 'block',
      alignSelf: 'center',
      justifySelf: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      ...(overlay && {
        position: 'fixed',
        inset: 0
      })
    }}
  />
)

export default CenterLoader
